import React from 'react';

import PropTypes from 'prop-types';

import { PromoIcon } from 'apps/promo/components/common/promo-icon/PromoIcon';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';

import styles from './Breadcrumbs.module.css';

export const Breadcrumbs = (props) => {
    const lastItem = props.breadcrumbsItems.pop();

    return (
        <div className={styles.container}>
            {props.breadcrumbsItems &&
                props.breadcrumbsItems.map((item) => {
                    return (
                        <PromoText key={`${item.name}-${item.url}`} tag="link" href={item.url}>
                            {item.name}
                            <span className={styles.iconWrap}>
                                <PromoIcon size="16px" name="chevron-right" color="primary" />
                            </span>
                        </PromoText>
                    );
                })}

            <PromoText color="gray80">{lastItem.name}</PromoText>
        </div>
    );
};

Breadcrumbs.propTypes = {
    breadcrumbsItems: PropTypes.array,
};
